module.exports = __webpack_public_path__ + "css/ocra.woff2.css";